/**
 * Modal Component
 * @module patterns/components/form-and-content/modal/modal
 */

import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';


export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Modal Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountModal(listeners);

            app.vueApp.component('stockland-modal', defineAsyncComponent(async () => import("./StocklandModal.vue")));
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Modal Component', error);
        });

    return function destroyModal() {
        unMountModal(listeners);

        app.logger.debug('[DXA] Modal Component destroyed');
    };
};

// Extracted method for logic reuse within other component
export function mountModal(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const modals = rootNode.querySelectorAll<HTMLElement>('.modal');


    // Handle background colour options for modal
    modals.forEach((modal) => {
        const updateBackgroundColour = () => {
            const backgroundColour = modal.dataset.modalBackground;
            const modalBackground = rootNode.querySelector<HTMLElement>('.modal-backdrop');
            backgroundColour && modalBackground && modalBackground.classList.add(backgroundColour);
        };

        modal.addEventListener('shown.bs.modal', updateBackgroundColour);
        listeners.push([modal, 'shown.bs.modal', updateBackgroundColour]);
    });
}

export function unMountModal(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
